/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoCreateDTO
 */
export interface AssistitoCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoCreateDTO
     */
    nome: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoCreateDTO
     */
    cognome: string;
}

/**
 * Check if a given object implements the AssistitoCreateDTO interface.
 */
export function instanceOfAssistitoCreateDTO(value: object): value is AssistitoCreateDTO {
    if (!('nome' in value) || value['nome'] === undefined) return false;
    if (!('cognome' in value) || value['cognome'] === undefined) return false;
    return true;
}

export function AssistitoCreateDTOFromJSON(json: any): AssistitoCreateDTO {
    return AssistitoCreateDTOFromJSONTyped(json, false);
}

export function AssistitoCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'],
        'cognome': json['cognome'],
    };
}

export function AssistitoCreateDTOToJSON(value?: AssistitoCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'cognome': value['cognome'],
    };
}

